/* YMM canonical vehicle dataset loader — fetch once, cache, share. */
window.VehicleData = (function () {
  'use strict';
  var CACHE_KEY = 'tso_vehicle_data';
  // Bump whenever the dataset SHAPE changes (new required fields), so warm
  // caches self-bust on deploy without an ymm_data_version metafield bump.
  // v2: rows carry *_id fields (drawer GID matcher) — id-less cached rows
  // would render every step empty (audit P0-1).
  var SCHEMA = 2;
  var TTL_MS = 24 * 60 * 60 * 1000;
  var ENDPOINT = '/pages/vehicle-data?view=fitment-data';
  var inflight = null;

  function currentToken() {
    var el = document.querySelector('meta[name="ymm-data-version"]');
    return el ? el.getAttribute('content') : null;
  }
  function readCache() {
    try { return JSON.parse(localStorage.getItem(CACHE_KEY) || 'null'); } catch (e) { return null; }
  }
  function writeCache(token, data, now) {
    try { localStorage.setItem(CACHE_KEY, JSON.stringify({ version: token, schema: SCHEMA, fetchedAt: now, data: data })); } catch (e) {}
  }
  function isCacheValid(cache, token, now, ttl, schema) {
    return !!cache && cache.schema === schema && cache.version === token && (now - cache.fetchedAt) < ttl;
  }
  function mergePages(pages) {
    var out = [];
    for (var i = 0; i < pages.length; i++) {
      var g = (pages[i] && pages[i].vehicleGenerations) || [];
      for (var j = 0; j < g.length; j++) out.push(g[j]);
    }
    return { vehicleGenerations: out };
  }
  function defaultFetchJson(url) {
    return fetch(url, { credentials: 'same-origin' }).then(function (r) {
      if (!r.ok) throw new Error('vehicle-data fetch ' + r.status);
      return r.json();
    });
  }
  function fetchAll(fetchJson) {
    return fetchJson(ENDPOINT).then(function (p1) {
      var pages = [p1];
      var param = (p1 && p1.page_param) ? p1.page_param : 'page';
      function next(n) {
        var last = pages[pages.length - 1];
        if (!last || !last.has_next) return mergePages(pages);
        var url = ENDPOINT + (ENDPOINT.indexOf('?') === -1 ? '?' : '&') + encodeURIComponent(param) + '=' + n;
        return fetchJson(url).then(function (pn) { pages.push(pn); return next(n + 1); });
      }
      return next(2);
    });
  }
  function getVehicleData() {
    var token = currentToken();
    var cache = readCache();
    if (isCacheValid(cache, token, Date.now(), TTL_MS, SCHEMA)) return Promise.resolve(cache.data);
    if (inflight) return inflight;
    inflight = fetchAll(defaultFetchJson).then(function (data) {
      writeCache(token, data, Date.now());
      inflight = null;
      return data;
    }).catch(function (e) {
      inflight = null;
      if (cache && cache.data) return cache.data; // stale-on-error
      throw e;
    });
    return inflight;
  }
  function warm() {
    var run = function () { getVehicleData().catch(function () {}); };
    if (window.requestIdleCallback) requestIdleCallback(run); else setTimeout(run, 1500);
  }
  return {
    getVehicleData: getVehicleData, warm: warm,
    isCacheValid: isCacheValid, mergePages: mergePages, fetchAll: fetchAll
  };
})();
